module.exports = __webpack_public_path__ + "static/Oven01-6d5cee1ed969fd5f031ae6b203b525a3.png";